import React, { type ReactNode } from "react";
import { Button } from "@progress/kendo-react-buttons";

interface GxApplyButtonProps {
  label?: string;
  handledrawerSubmit: () => void;
  className?: string;
  children?: ReactNode;
  icon?: ReactNode;
  loading?: boolean;
  disabled?: boolean;
}

const GxApplyButtonPayee: React.FC<GxApplyButtonProps> = ({
  handledrawerSubmit,
  label,
  children,
  icon,
  loading = false,
  disabled = false,
  className = "",
}) => {

  return (
    <Button
      type="button"
      onClick={handledrawerSubmit}
      disabled={disabled || loading}
      className={`gx-apply-btn gx-drawer-save-button-payee ${
        disabled ? "gx-apply-btn--disabled opacity-50 !cursor-not-allowed" : ""
      } ${loading ? "gx-apply-btn--loading" : ""} ${className}`}
    >
      <span className="gx-p12-b p-3 flex items-center gap-2">
        {icon}
        {label}
        {children}
      </span>
    </Button>
  );
};

export default GxApplyButtonPayee;


